import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'returns/initiate', pathMatch: 'full' },
  { path: 'tax-payer-services', redirectTo: 'about-us', pathMatch: 'full' },
  { path: 'help', redirectTo: 'help/contact-information', pathMatch: 'full' },
  {
    path: 'about-us',
    loadComponent: () =>
      import('@shared-lib/components/footer/footer.component').then(
        (m) => m.FooterComponent
      ),
    title: 'About Us',
    data: { footerKey: 'about-us', breadcrumb: 'About Us' },
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('@shared-lib/components/footer/footer.component').then(
        (m) => m.FooterComponent
      ),
    title: 'Privacy Policy',
    data: { footerKey: 'privacy-policy', breadcrumb: 'Privacy Policy' },
  },
  {
    path: 'terms-of-use',
    loadComponent: () =>
      import('@shared-lib/components/footer/footer.component').then(
        (m) => m.FooterComponent
      ),
    title: 'Terms of Use',
    data: { footerKey: 'terms-of-use', breadcrumb: 'Terms of Use' },
  },
  {
    path: 'accessibility',
    loadComponent: () =>
      import('@shared-lib/components/footer/footer.component').then(
        (m) => m.FooterComponent
      ),
    title: 'Accessibility',
    data: { footerKey: 'accessibility', breadcrumb: 'Accessibility' },
  },
  {
    path: 'site-map',
    loadComponent: () =>
      import('@shared-lib/components/footer/footer.component').then(
        (m) => m.FooterComponent
      ),
    title: 'Sitemap',
    data: { footerKey: 'site-map', breadcrumb: 'Sitemap' },
  },
  {
    path: 'help/contact-information',
    loadComponent: () =>
      import('@shared-lib/components/footer/footer.component').then(
        (m) => m.FooterComponent
      ),
    title: 'Contact Information',
    data: { footerKey: 'contact-info', breadcrumb: 'Contact Information' },
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./components/dashboard-redirect/dashboard-redirect.component').then(
        (m) => m.DashboardRedirectComponent
      ),
  },
  {
    path: 'dmtt/dmtt-registration',
    data: { useRegistrationUrl: true },
    loadComponent: () =>
      import('./components/dashboard-redirect/dashboard-redirect.component').then(
        (m) => m.DashboardRedirectComponent
      ),
  },
  {
    path: 'dmtt/dmtt-registration/new',
    data: { redirectPath: '/dmtt/dmtt-registration/new' },
    loadComponent: () =>
      import('./components/dashboard-redirect/dashboard-redirect.component').then(
        (m) => m.DashboardRedirectComponent
      ),
  },
  {
    path: 'dmtt/dmtt-registration/modify',
    data: { redirectPath: '/dmtt/dmtt-registration/modify' },
    loadComponent: () =>
      import('./components/dashboard-redirect/dashboard-redirect.component').then(
        (m) => m.DashboardRedirectComponent
      ),
  },
  {
    path: 'dmtt/dmtt-registration/track',
    data: { redirectPath: '/dmtt/dmtt-registration/track' },
    loadComponent: () =>
      import('./components/dashboard-redirect/dashboard-redirect.component').then(
        (m) => m.DashboardRedirectComponent
      ),
  },
  {
    path: 'dmtt/payments-and-funds',
    data: { redirectPath: '/dmtt/payments-and-funds' },
    loadComponent: () =>
      import('./components/dashboard-redirect/dashboard-redirect.component').then(
        (m) => m.DashboardRedirectComponent
      ),
  },
  {
    path: 'returns',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/returns.routes').then((m) => m.RETURNS_ROUTES),
    data: { breadcrumb: 'Returns' },
  },
  {
    path: 'notification',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('@shared-lib/components/in-app-notifications/in-app-notifications.component').then(
        (m) => m.InAppNotificationsComponent
      ),
    title: 'DMTT Notifications',
    data: { breadcrumb: [
      {label:'Notifications', url: '/notification' },
    ] },
  },
  { path: '**', redirectTo: 'returns/initiate' },
];
